import { JSX } from "react";

interface RoundedLegendIconProps {
  fill?: string;
}

const RoundedLegendIcon = ({ fill }: RoundedLegendIconProps): JSX.Element => (
  <rect x={0} y={0} width={32} height={32} rx={8} ry={8} fill={fill} />
);

export { RoundedLegendIcon };
